window.LoopTranslations = {
  PT: {
    // Dogs section
    dogs: {
      yourDogs: "Os meus cães",
      addNewDog: "Adicionar novo cão",
      name: "Nome",
      gender: "Género",
      lifeStage: "Fase da vida",
      weight: "Peso",
      male: "Macho",
      female: "Fêmea",
      puppy: "Cachorro",
      adult: "Adulto",
      senior: "Sénior",
      save: "Guardar",
      deleteProfile: "Apagar Perfil",
      cancel: "Cancelar",
      editDog: "Editar cão",
      deleteDogConfirmation: "Tem a certeza que quer apagar este perfil?",
      deleteDogWarning: "Depois de apagar, não poderá recuperar o perfil.",
      deleteDogNote:
        "Apagar o perfil do seu cão não elimina o plano. Para isso, clique no botão lateral 'Gerir encomendas'",
      thisPlanIsFor: "Este plano é para:",
      enterDogName: "Inserir nome do cão",
      enterDogWeight: "Inserir peso do cão",
      forDogs: "Para %s",
      articleMale: "o",
      articleFemale: "a",
      nameSeparator: "e",
      saveError: "Não foi possível guardar. Tente novamente.",
      loadError: "Não foi possível carregar os seus cães.",
      noDogs: "Ainda não tem cães adicionados.",
      requiredFields: "Preencha: %s.",
      sessionExpired: "A sua sessão expirou. Volte a iniciar sessão.",
      duplicateName: "Já tem um cão com este nome. Escolha outro nome.",
    },

    // UI elements
    ui: {
      see: "Ver",
      close: "Fechar",
      cancel: "Cancelar",
      save: "Guardar",
      edit: "Editar",
      delete: "Apagar",
      confirm: "Confirmar",
      loading: "A carregar...",
      retry: "Tentar novamente",
      error: "Erro",
      success: "Sucesso",
      update: "Atualizar",
      seeMore: "Ver mais",
    },

    // Wallet section
    wallet: {
      title: "Wallet",
      knowMore: "Saber mais",
      close: "Fechar",
      earnCredit: "Ganhe crédito em cada encomenda:",
      earnCreditDesc: "Ganhe crédito com cada encomenda de plano e reforce a rotina do seu cão com novos produtos",
      expiry: "Expiração:",
      expiryDesc: "O crédito expira após 60 dias sem encomendas",
      expiresIn: "Crédito expira em %d dias",
      expiresInOne: "Crédito expira em 1 dia",
      expiresInToday: "Crédito expira hoje",
      expired: "Expirado",
      addProductWithWallet: "Usar crédito da wallet",
      productAddedSuccess: "Produto adicionado com sucesso!",
      productAddedError: "Erro ao adicionar produto. Tente novamente.",
      insufficientBalance: "Saldo insuficiente na Wallet",
      addProductSuccess: "Produto adicionado à próxima encomenda",
      youHaveCredit: "Tem %s€ na sua wallet",
      notEnoughCredit: "Não tem crédito suficiente. Tem %s€ na wallet",
      cantUseForSubscriptions: "Não pode usar crédito para subscrições",
      reactivateToUseWallet:
        "Reativar plano para usar o crédito da Wallet",
      reactivateDesc:
        "Depois de reativar poderá trocar o seu crédito por produtos.",
    },

    // Orders & Subscription
    orders: {
      deliveredEveryMonth: "· Entregue todos os meses",
      lastOrderCharged: "A última encomenda foi cobrada em %s",
      quantity: "Quantidade: %d",
      processingInfo:
        "Estamos a processar a sua encomenda. O estado será atualizado automaticamente dentro de instantes.",
      processingDelayed:
        "O processamento da sua encomenda está a demorar mais tempo do que o habitual. Consulte o estado da encomenda mais tarde.",
      // WEB-152: order history drawer (pending Sofia approval)
      downloadInvoice: "Descarregar fatura",
      invoiceNotAvailable: "A fatura desta encomenda ainda não está disponível.",
      invoiceError: "Não foi possível descarregar a fatura. Tente novamente mais tarde.",
    },

    shipping: {
      shippingCost: "%s€ entrega",
      freeShipping: "· Entrega gratuita",
    },

    // User actions
    user: {
      logout: "Encerrar sessão",
      login: "Iniciar sessão",
      profile: "Perfil",
      account: "Conta",
      subscription: "Plano",
      subscriptionCancelled: "O seu plano está cancelado",
      subscriptionTitle: "Plano de",
      reactivate: "Reativar",
      reactivateAndOrderNow: "Reativar e encomendar agora",
      reactivateConfirm:
        "Ao clicar no botão “OK”, irá reativar o seu plano e processaremos a sua encomenda.",
      subscriptionCancelledDesc:
        "Clique em “<strong>Reativar</strong>” para alterar ou remover produtos do seu plano. <br> Se pretende receber o seu plano agora, tal como está, clique em “<strong>Reativar e encomendar agora</strong>”.",
      editProduct: "Editar produto",
      removeProduct: "Remover",
      addedWithWallet: "Adicionado com wallet",
      confirmDelete:
        "Tem a certeza que deseja remover este produto do seu plano?",
      cannotRemoveLastProduct:
        "Este é o único produto da subscrição, por isso não pode ser removido.",
    },

    errors: {
      generic: "Ocorreu um erro. Por favor, tente novamente.",
      paymentError: {
        title: "Não foi possível processar o seu pagamento",
        description:
          "Atualize o método de pagamento para concluir a encomenda.\nSe estiver a usar um cartão de compra única, tente em alternativa um cartão de pagamento recorrente.",
        cta: "Atualizar cartão",
        retry: "Tentar novamente",
        byCategory: {
          CARD_EXPIRED: {
            title: "O seu cartão expirou",
            description: "Atualize o seu cartão para finalizar a sua encomenda.",
          },
          INCORRECT_CARD_NUMBER: {
            title: "O número do seu cartão está inválido",
            description: "Verifique os dados do seu cartão e tente novamente.",
          },
          INSUFFICIENT_FUNDS: {
            title: "O cartão não tem fundos",
            description:
              "Para terminar a sua encomenda, atualize o seu cartão.",
          },
          INVALID_PAYMENT_METHOD: {
            title: "Método de pagamento inválido",
            description:
              "Adicione um novo cartão para continuar. Se estiver a usar um cartão de compra única, tente um cartão de pagamento recorrente.",
          },
          CARD_TYPE_NOT_SUPPORTED: {
            title: "Este cartão não suporta pagamentos recorrentes",
            description:
              "Habitualmente acontece com cartões de compra única (temporários ou virtuais). Tente um cartão físico ou, se precisar de um cartão temporário, escolha um que permita pagamentos recorrentes.",
          },
          PAYMENT_METHOD_REVOKED: {
            title: "O seu método de pagamento foi removido",
            description:
              "Adicione um novo método de pagamento para continuar. Se estiver a usar um cartão de compra única, tente um cartão de pagamento recorrente.",
          },
          FRAUD_SUSPECTED: {
            title: "Não foi possível confirmar o pagamento",
            description:
              "Tente outro método de pagamento.",
          },
          INVALID_ADDRESS: {
            title: "Morada de envio incompleta ou incorreta",
            description: "Verifique a morada na secção Morada de entrega, mais abaixo nesta página. Depois de corrigir a informação, tente novamente.",
          },
          AUTHENTICATION_FAILED: {
            title: "Não foi possível confirmar a autenticação do pagamento",
            description: "Tente novamente ou utilize outro método de pagamento.",
          },
          PAYPAL_AGREEMENT_CANCELLED: {
            title: "O seu acordo do PayPal foi cancelado",
            description:
              "Associe novamente o PayPal ou adicione outro método de pagamento.",
          },
          PAYPAL_AGREEMENT_INVALID: {
            title: "O seu acordo do PayPal é inválido",
            description:
              "Associe novamente o PayPal ou adicione outro método de pagamento.",
          },
          PAYPAL_GENERAL_ERROR: {
            title: "Ocorreu um erro com o PayPal",
            description: "Tente novamente ou utilize outro método de pagamento.",
          },
          INVALID_CUSTOMER: {
            title: "Não foi possível validar os seus dados",
            description: "Por favor contacte o nosso suporte.",
          },
          GENERIC_ERROR: {
            title: "Não foi possível processar o seu pagamento",
            description:
              "Atualize o seu cartão ou tente outro para que a sua encomenda seja processada. Se estiver a usar um cartão de compra única, tente um cartão de pagamento recorrente.",
          },
          INVALID_GIFT_CARD_AMOUNT: {
            title: "O valor do cartão de oferta não é válido",
            description: "Utilize outro método de pagamento.",
          },
          INSUFFICIENT_INVENTORY: {
            title: "Não há stock suficiente para a encomenda",
            description: "Remova o produto em falta para finalizar a encomenda.",
          },
          NO_INVENTORY_LOCATION: {
            title: "Não foi possível localizar o stock para esta encomenda.",
            description: "Por favor contacte o nosso suporte para resolver esta situação.",
          },
          INVALID_CURRENCY: {
            title: "Ocorreu um erro com a moeda do pagamento.",
            description:
              "Por favor contacte o nosso suporte para resolver esta situação.",
          },
          INVOICE_ALREADY_PAID: {
            title: "Esta encomenda já foi paga",
            description: "Não é necessária nenhuma ação da sua parte.",
          },
          MERCHANT_ACCOUNT_ERROR: {
            title: "Ocorreu um erro no processamento do pagamento",
            description: "Por favor contacte o nosso suporte para resolver esta situação.",
          },
          GATEWAY_TEST_MODE_ERROR: {
            title: "Ocorreu um erro no processamento do pagamento",
            description: "Por favor contacte o nosso suporte para resolver esta situação.",
          },
          PAYMENT_PROVIDER_ERROR: {
            title: "Ocorreu um erro no processamento do pagamento",
            description: "Tente novamente dentro de alguns segundos.",
          },
          PAYMENT_PROVIDER_NOT_ENABLED: {
            title: "Este método de pagamento não está disponível",
            description: "Utilize outro método de pagamento.",
          },
          TRANSACTION_LIMIT_EXCEEDED: {
            title: "Não foi possível processar o seu pagamento",
            description: "Adicione um novo cartão para continuar. Se estiver a usar um cartão de compra única, tente um cartão de pagamento recorrente.",
          },
          TRANSIENT_ERROR: {
            title: "Ocorreu um erro temporário ao processar o pagamento",
            description: "Tente novamente dentro de alguns segundos.",
          },
          AMOUNT_OUT_OF_RANGE: {
            title: "O valor da transação não é válido",
            description: "Contacte o nosso suporte.",
          },
        },
      },
    },
  },

  IT: {
    // Dogs section
    dogs: {
      yourDogs: "I miei cani",
      addNewDog: "Aggiungi nuovo cane",
      name: "Nome",
      gender: "Sesso",
      lifeStage: "Fase della vita",
      weight: "Peso",
      male: "Maschio",
      female: "Femmina",
      puppy: "Cucciolo",
      adult: "Adulto",
      senior: "Senior",
      save: "Salva",
      deleteProfile: "Elimina Profilo",
      cancel: "Annulla",
      editDog: "Modifica cane",
      deleteDogConfirmation: "Sei sicuro di voler eliminare questo profilo?",
      deleteDogWarning:
        "Dopo l'eliminazione, non potrai recuperare il profilo.",
      deleteDogNote:
        "Eliminare il profilo del tuo cane non elimina il piano. Per farlo, clicca sul pulsante laterale 'Gestisci ordini'",
      thisPlanIsFor: "Questo piano è per:",
      enterDogName: "Inserisci nome del cane",
      enterDogWeight: "Inserisci peso del cane",
      forDogs: "Per %s",
      articleMale: "",
      articleFemale: "",
      nameSeparator: "e",
      saveError: "Non è stato possibile salvare. Riprova.",
      loadError: "Non è stato possibile caricare i tuoi cani.",
      noDogs: "Non hai ancora aggiunto cani.",
      requiredFields: "Compila: %s.",
      sessionExpired: "La tua sessione è scaduta. Accedi di nuovo.",
      duplicateName: "Hai già un cane con questo nome. Scegli un altro nome.",
    },

    // UI elements
    ui: {
      see: "Vedi",
      close: "Chiudi",
      cancel: "Annulla",
      save: "Salva",
      edit: "Modifica",
      delete: "Elimina",
      confirm: "Conferma",
      loading: "Caricamento...",
      retry: "Riprova",
      error: "Errore",
      success: "Successo",
      update: "Aggiorna",
      seeMore: "Vedi di più",
    },

    // Wallet section
    wallet: {
      title: "Wallet",
      knowMore: "Scopri di più",
      close: "Chiudi",
      earnCredit: "Guadagna credito ad ogni ordine:",
      earnCreditDesc:
        "Guadagna credito con ogni ordine e riscattalo per i prodotti.",
      expiry: "Scadenza:",
      expiryDesc: "Il credito scade dopo 45 giorni senza ordini.",
      expiresIn: "Scade tra %d giorni",
      expiresInOne: "Scade tra 1 giorno",
      expiresInToday: "Scade oggi",
      expired: "Scaduto",
      addProductWithWallet: "Aggiungi prodotto con Wallet",
      productAddedSuccess: "Prodotto aggiunto con successo!",
      productAddedError: "Errore nell'aggiunta del prodotto. Riprova.",
      insufficientBalance: "Saldo insufficiente nel Wallet",
      addProductSuccess: "Prodotto aggiunto al prossimo ordine",
      youHaveCredit: "Hai %s€",
      notEnoughCredit: "Non hai abbastanza credito. Hai %s€",
      cantUseForSubscriptions: "Non puoi usare il credito per gli abbonamenti",
      reactivateToUseWallet:
        "Riattiva l'abbonamento per usare il credito della Wallet",
      reactivateDesc:
        "Dopo la riattivazione potrai scambiare il tuo credito con prodotti.",
    },

    // Orders & Subscription
    orders: {
      deliveredEveryMonth: "· Consegnato ogni mese",
      lastOrderCharged: "L'ultimo ordine è stato addebitato il %s",
      quantity: "Quantità: %d",
      processingInfo:
        "Stiamo elaborando il tuo ordine. Lo stato si aggiornerà automaticamente tra pochi istanti.",
      processingDelayed:
        "L'elaborazione del tuo ordine sta richiedendo più tempo del solito. Controlla lo stato dell'ordine più tardi.",
    },

    shipping: {
      shippingCost: "%s€ spedizione",
      freeShipping: "· Spedizione gratuita",
    },

    // User actions
    user: {
      logout: "Esci",
      login: "Accedi",
      profile: "Profilo",
      account: "Account",
      subscription: "Abbonamento",
      subscriptionCancelled: "Il tuo piano è stato annullato",
      subscriptionTitle: "Abbonamento di",
      reactivate: "Riattiva",
      reactivateAndOrderNow: "Riattiva e ordina ora",
      reactivateConfirm:
        "Cliccando su “OK”, riattiverai il tuo piano e processeremo il tuo ordine.",
      subscriptionCancelledDesc:
        "Fai clic su “<strong>Riattiva</strong>” per modificare o rimuovere prodotti dal tuo piano. <br> Se vuoi ricevere il tuo piano così com’è e ordinare subito, fai clic su “<strong>Riattiva e ordina ora</strong>”.",
      editProduct: "Modifica prodotto",
      removeProduct: "Rimuovi",
      addedWithWallet: "Aggiunto con wallet",
      confirmDelete:
        "Sei sicuro di voler rimuovere questo prodotto dal tuo piano?",
      cannotRemoveLastProduct:
        "Questo è l'unico prodotto dell'abbonamento, per cui non può essere rimosso.",
    },

    errors: {
      generic: "Si è verificato un errore. Riprova.",
      paymentError: {
        title: "Non siamo riusciti a elaborare il tuo pagamento",
        description:
          "Aggiorna il metodo di pagamento per completare il tuo ordine.\nSe stai utilizzando una carta per pagamenti una tantum, prova con una carta che supporti pagamenti ricorrenti.",
        cta: "Aggiorna metodo di pagamento",
        retry: "Riprova",
      },
    },
  },

  ES: {
    // Dogs section
    dogs: {
      yourDogs: "Mis perros",
      addNewDog: "Añadir nuevo perro",
      name: "Nombre",
      gender: "Género",
      lifeStage: "Etapa de vida",
      weight: "Peso",
      male: "Macho",
      female: "Hembra",
      puppy: "Cachorro",
      adult: "Adulto",
      senior: "Senior",
      save: "Guardar",
      deleteProfile: "Eliminar Perfil",
      cancel: "Cancelar",
      editDog: "Editar perro",
      deleteDogConfirmation:
        "¿Estás seguro de que quieres eliminar este perfil?",
      deleteDogWarning: "Después de eliminar, no podrás recuperar el perfil.",
      deleteDogNote:
        "Eliminar el perfil de tu perro no elimina el plan. Para eso, haz clic en el botón lateral 'Gestionar pedidos'",
      thisPlanIsFor: "Este plan es para:",
      enterDogName: "Introducir nombre del perro",
      enterDogWeight: "Introducir peso del perro",
      forDogs: "Para %s",
      articleMale: "",
      articleFemale: "",
      nameSeparator: "y",
      saveError: "No se ha podido guardar. Inténtalo de nuevo.",
      loadError: "No se han podido cargar tus perros.",
      noDogs: "Aún no tienes perros añadidos.",
      requiredFields: "Rellena: %s.",
      sessionExpired: "Tu sesión ha caducado. Vuelve a iniciar sesión.",
      duplicateName: "Ya tienes un perro con este nombre. Elige otro nombre.",
    },

    // UI elements
    ui: {
      see: "Ver",
      close: "Cerrar",
      cancel: "Cancelar",
      save: "Guardar",
      edit: "Editar",
      delete: "Eliminar",
      confirm: "Confirmar",
      loading: "Cargando...",
      retry: "Intentar de nuevo",
      error: "Error",
      success: "Éxito",
      update: "Actualizar",
      seeMore: "Ver más",
    },

    // Wallet section
    wallet: {
      title: "Wallet",
      knowMore: "Saber más",
      close: "Cerrar",
      earnCredit: "Gana crédito en cada pedido:",
      earnCreditDesc: "Gana crédito con cada pedido y canjéalo por productos.",
      expiry: "Caducidad:",
      expiryDesc: "El crédito caduca tras 45 días sin pedir.",
      expiresIn: "Caduca en %d días",
      expiresInOne: "Caduca en 1 día",
      expiresInToday: "Caduca hoy",
      expired: "Caducado",
      addProductWithWallet: "Añadir producto con Wallet",
      productAddedSuccess: "¡Producto añadido con éxito!",
      productAddedError: "Error al añadir producto. Inténtalo de nuevo.",
      insufficientBalance: "Saldo insuficiente en Wallet",
      addProductSuccess: "Producto añadido al próximo pedido",
      youHaveCredit: "Tienes %s€",
      notEnoughCredit: "No tienes suficiente crédito. Tienes %s€",
      cantUseForSubscriptions: "No puedes usar crédito para suscripciones",
      reactivateToUseWallet:
        "Reactivar suscripción para usar el crédito de la Wallet",
      reactivateDesc:
        "Después de reactivar podrás intercambiar tu crédito por productos.",
    },

    // Orders & Subscription
    orders: {
      deliveredEveryMonth: "· Entregado cada mes",
      lastOrderCharged: "El último pedido se cobró el %s",
      quantity: "Cantidad: %d",
      processingInfo:
        "Estamos procesando tu pedido. El estado se actualizará automáticamente en unos instantes.",
      processingDelayed:
        "El procesamiento de tu pedido está tardando más de lo habitual. Consulta el estado del pedido más tarde.",
    },

    shipping: {
      shippingCost: "%s€ entrega",
      freeShipping: "· Entrega gratuita",
    },

    // User actions
    user: {
      logout: "Cerrar sesión",
      login: "Iniciar sesión",
      profile: "Perfil",
      account: "Cuenta",
      subscription: "Suscripción",
      subscriptionCancelled: "Tu plan está cancelado",
      subscriptionTitle: "Suscripción de",
      reactivate: "Reactivar",
      reactivateAndOrderNow: "Reactivar y pedir ahora",
      reactivateConfirm:
        "Al hacer clic en “OK”, reactivarás tu plan y tramitaremos tu pedido.",
      subscriptionCancelledDesc:
        "Haz clic en “<strong>Reactivar</strong>” para editar o eliminar productos de tu plan. <br> Si quieres recibir tu plan tal cual y pedir ahora, haz clic en “<strong>Reactivar y pedir ahora</strong>”.",
      editProduct: "Editar producto",
      removeProduct: "Eliminar",
      addedWithWallet: "Añadido con wallet",
      confirmDelete:
        "¿Estás seguro de que deseas eliminar este producto de tu plan?",
      cannotRemoveLastProduct:
        "Este es el único producto de la suscripción, por lo que no se puede eliminar.",
    },

    errors: {
      generic: "No pudimos procesar tu pago",
      paymentError: {
        title: "Non siamo riusciti a elaborare il tuo pagamento",
        description:
          "Por favor, actualiza tu método de pago para completar tu pedido.\nSi estás utilizando una tarjeta de un solo uso, prueba con una tarjeta que permita pagos recurrentes.",
        cta: "Actualizar método de pago",
        retry: "Intentar de nuevo",
      },
    },
  },
};
